/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockItemsDto as DigiworkMaitreDPosDtoStockItemStockItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-items-dto';

export interface GetStockItems$Params {
  code?: number;
  searchTerm?: string;
  isRemoved?: boolean;
}

export function getStockItems(http: HttpClient, rootUrl: string, params?: GetStockItems$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemsDto>> {
  const rb = new RequestBuilder(rootUrl, getStockItems.PATH, 'get');
  if (params) {
    rb.query('code', params.code, {});
    rb.query('searchTerm', params.searchTerm, {});
    rb.query('isRemoved', params.isRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemsDto>;
    })
  );
}

getStockItems.PATH = '/api/stock-items';
